import { MessageActionType } from "pubnub-redux";
import { APIPubNubWorkflowEvents, RootAction, APIPubNubWorkflowResponse } from "../../types";

export interface PubNubWorkflowState {
  byId: Record<string, APIPubNubWorkflowResponse>;
}

const blankState = () => ({});

export interface MessageState {
  newestMessageId?: string;
  newestConversationId?: string;
  messages?: APIPubNubWorkflowEvents[];
  newMessage?: boolean;
  readAt?: Date;
  conversationEnd?: boolean;
  fireUnreadCount?: boolean;
}

const pubNubWorkflowReducer = (state: State = blankState(), action: RootAction): State => {
  switch (action.type) {
    case MessageActionType.MESSAGE_RECEIVED: {
      if (!action || !action.payload || !action.payload.message) return state;

      const apiResponse = action.payload.message as APIPubNubWorkflowResponse;
      if ("workflow_status_id" in apiResponse) {
        const workflowKey = action.payload.channel;
        return {
          ...state,
          [workflowKey]: { ...apiResponse }
        };
      } else {
        return state;
      }
    }
    default:
      return state;
  }
};
export default pubNubWorkflowReducer;
